import axios from 'axios';
import { getAuthHeaders } from '../../../Auth';

const REQUESTOR = 'AG_Playground';
const CAM_URL = 'https://prod.cams.contentauthoring.cimpress.io';

export interface ContentAuthoringTenant {
    accountId: string;
    accountName: string;
    contentAreaId: string;
    contentAreaName: string;
    description: string;
    contentAuthoringAreaName: string;
    contentAuthoringAreaId: string;
    contentAuthoringAccountName: string;
    contentAuthoringAccountId: string;
}

export interface CamTenant {
    accountId: string;
    contentAreaId: string;
    contentAuthoringAreaId: string;
    contentAuthoringAccountId: string;
}

export interface ConceptKit {
    id: string;
    assetName: string;
    accountId: string;
    contentAreaId: string;
    assetKind: string;
    assetType: string;
    designConceptId?: string;
    latestVersion?: {
        contentAsset?: {
            assetId?: string;
            uploadInfo?: {
                fileUrl?: string;
            };
        };
    };
}

interface ConceptKitPaginatedResponse {
    totalCount: number;
    maximumPagingDepth: number;
    data: ConceptKit[];
}

export async function getConceptKits(): Promise<string[]> {
    try {
        //Hardcoding the vista tenant for now.
        const camUrl = `${CAM_URL}/api/v4/ozoDdrmewShEcbUDWX8J3V/BariCgbVOzbaYywM/assets?published=true&assetType=management&assetKind=conceptKit&requestor=${REQUESTOR}`;

        const headers = await getAuthHeaders();
        const response = await axios.get(camUrl, {
            headers,
        });
        const result: ConceptKitPaginatedResponse = response.data;

        const conceptKitIds = result.data
            .map((conceptKit) => conceptKit.latestVersion?.contentAsset?.assetId)
            .filter((id) => id !== undefined);
        return conceptKitIds;
    } catch (e) {
        throw new Error('getConceptKits failed');
    }
}
